import { Component, OnInit, ViewEncapsulation, ViewChild, OnDestroy } from '@angular/core';
import { AppState } from '../../../models/appState';
import { Subscription } from 'rxjs';
import { UploadService } from '../../../services/upload.service';
import { DataSourceService } from '../../../services/data-source.service';
import { AuthenticationService } from 'projects/bimbo/src/app/services/authentication.service';
import { MatDialog, MatTabChangeEvent, MatSelectChange } from '@angular/material';
import { LogicService } from '../../../services/logic.service';
import { SavingParameters, PeriodTypeEnum, LoanParameters, Range, Parameter } from '@akiba/models_bimbo';
import { InfoDialogComponent } from '../../../dialogs/info-dialog/info-dialog.component';
import { CancelConfirmDialogComponent } from '../../../dialogs/cancel-confirm-dialog/cancel-confirm-dialog.component';
import { UiService } from '../../../services/ui.service';

@Component({
  selector: 'app-retirement-saving-parameters',
  templateUrl: './retirement-saving-parameters.component.html',
  styleUrls: ['./retirement-saving-parameters.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RetirementSavingParametersComponent implements OnInit, OnDestroy {

  modParameter: Parameter | null = null;
  savingParameters: Array<Parameter> = new Array<Parameter>();
  parameterSubscription: Subscription;
  contentLocation: AppState = new AppState();
  selectedIndex = 0;

  tempPeriod: SavingParameters;
  isEdit = false;
  isNew = false;
  hideActions = false;
  tmpHasDR: boolean | undefined;

  uploadSubscription: Subscription = null;
  appLogicChangesSubscription: Subscription = null;
  @ViewChild('name', {static: false}) name: any;
  constructor(public authService: AuthenticationService, private uploadService: UploadService, private dataService: DataSourceService, public dialog: MatDialog, public logicService: LogicService, public ui: UiService) {

    if (!this.logicService.dataManager.parameterDataLoader.parameters) {

      this.parameterSubscription = this.logicService.dataManager.parameterDataLoader.changes.subscribe(p => {

        if (p && p.response) {
          this.savingParameters = this.logicService.dataManager.parameterDataLoader.parameters.map(element => new Parameter(element)).filter(element => element.type === 3);
        }

      });

      this.logicService.dataManager.parameterDataLoader.load();

    } else {

      this.savingParameters = this.logicService.dataManager.parameterDataLoader.parameters.map(element => new Parameter(element)).filter(element => element.type === 3);

    }

  }

  ngOnInit() {
    this.modParameter = new Parameter();
    this.contentLocation.savingParametersIndex = 0;
  }

  keyUpMethod(event: string) {
    if (event) {
      this.isNew = true;
    } else {
      this.isNew = false;
      this.contentLocation.savingParametersIndex = 0;
    }
  }

  tabChanged(event: MatTabChangeEvent): void {
    this.selectedIndex = event.index;
  }

  selectedPeriodChange(event: MatSelectChange) {

    if (!event.value) {
      this.modParameter = new Parameter();
      this.isEdit = false;
      this.tempPeriod = null;
      this.hideActions = false;
      this.contentLocation.savingParametersIndex = 0;
    } else {
      this.modParameter = event.value;
      this.isEdit = true;
      this.tmpHasDR = this.modParameter.hasDRDistribution;
      this.tempPeriod = event.value;
    }

  }

  savePeriod() {
    const authUser = this.logicService.dataManager.principalDataLoader.employee ? this.logicService.dataManager.principalDataLoader.employee : this.authService.authEmployee;
    this.modParameter.type = PeriodTypeEnum.retirementSaving;
    this.modParameter.active = true;
    this.modParameter.savingParameter.factor = 1;

    if (!this.modParameter.loansParameters.length) {
      const lp = new LoanParameters();
      lp.applicableSeniorityRange = new Range({start: 0, end: 100});
      this.modParameter.loansParameters.push(lp);
    }

    if (!this.modParameter.savingParameter.includedCompanies || !this.modParameter.savingParameter.includedCompanies.length) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'Se debe de incluir al menos una compañía.',
          close: 'Aceptar'
        }
      });

      return;

    }


    if (!this.modParameter.title) {

      this.dialog.open(InfoDialogComponent, {
        data: {
          message: 'El nombre del ciclo es requerido.',
          close: 'Aceptar'
        }
      });

      return;

    }

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea guardar el ciclo con la información dada?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });

    dialogConfirmation.afterClosed().subscribe(result => {

      if (result) {
        let createDate = new Date();
        let paramLogs = {
          changeID: '',
          collection: 'parameters',
          approvedUid: authUser.uid,
          approvedBy: {
            firstName: authUser.firstName,
            firstLastName: authUser.firstLastName,
            employeeNumber: authUser.workInformation.employeeNumber,
          },
          createDate: createDate,
          timeStamp: createDate.getTime()
        };

        if (this.modParameter.parametersID.length < 1){
          const dateId = new Date();
          this.modParameter.parametersID = dateId.getTime().toString();
        }
        this.ui.showSpinner();

        if (this.modParameter.savingParameter.fileUploaded.file) {

          this.uploadService.pushUpload(this.modParameter.savingParameter.fileUploaded);
          this.uploadSubscription = this.uploadService.downloadURLSubject.subscribe(downloadURL => {

            const p = this.modParameter;
            p.savingParameter.fileUploaded.file = null;
            p.savingParameter.fileUploaded.downloadURL = downloadURL;

            if (this.uploadSubscription && !this.uploadSubscription.closed) {
              this.uploadSubscription.unsubscribe();
              this.uploadSubscription = null;
            }

            const aPeriodObj = p.toAny();
            paramLogs.changeID = aPeriodObj.parametersID;
            this.dataService.saveLogAdministratorActions(paramLogs ,'retirementSavingParametersFileUploaded');
            this.dataService.saveParameter(aPeriodObj).then(() => {
              this.ui.stopSpinner();
              this.reset();

              this.dialog.open(InfoDialogComponent, {
                data: {
                  message: 'La información ha sido actualizada',
                  close: 'Aceptar'
                }
              });

            });

          });

        } else {

          const aPeriodObj = this.modParameter.toAny();
          paramLogs.changeID = aPeriodObj.parametersID;
          this.dataService.saveLogAdministratorActions(paramLogs ,'retirementSavingParameters');
          this.dataService.saveParameter(aPeriodObj).then(() => {
            this.ui.stopSpinner();
            this.reset();

            this.dialog.open(InfoDialogComponent, {
              data: {
                message: 'La información ha sido actualizada',
                close: 'Aceptar'
              }
            });

          });

        }

      }
    });

  }

  cancelPeriodChanges() {

    const dialogConfirmation = this.dialog.open(CancelConfirmDialogComponent, {
      data: {
        message: '¿Desea descartar los cambios hechos?',
        cancelButton: 'Cancelar',
        confirmButton: 'Aceptar'
      }
    });
    dialogConfirmation.afterClosed().subscribe(async result => {
      if (result) {
        this._setOriginalValues();
        this.reset();
      }
    });

  }

  reset() {

    this.modParameter = new Parameter();
    this.tempPeriod = null;
    this.contentLocation.savingParametersIndex = 0;
    this.isNew = false;
    this.isEdit = false;
    this.name.reset();
    this.selectedIndex = 0;

  }

  hideActionButtons(hide: boolean) {
    this.hideActions = hide;
  }

  ngOnDestroy(): void {

    if (this.uploadSubscription && !this.uploadSubscription.closed) {
      this.uploadSubscription.unsubscribe();
      this.uploadSubscription = null;
    }

    if (this.appLogicChangesSubscription && !this.appLogicChangesSubscription.closed) {
      this.appLogicChangesSubscription.unsubscribe();
      this.appLogicChangesSubscription = null;
    }

    if (this.parameterSubscription && !this.parameterSubscription.closed) {
      this.parameterSubscription.unsubscribe();
      this.parameterSubscription = null;
    }

  }

  private _setOriginalValues() {
    if (this.tmpHasDR !== undefined) {
      this.modParameter.hasDRDistribution = this.tmpHasDR;
    }
  }

}
